import React from "react";

const HowItWorks = () => {
  return (
    <section className="section dark how" id="how-it-works">
      <div className="container">
        <div className="how-head">
          <h2 className="section-title">How MICRO 24 Changes Combustion</h2>
          <p className="section-subtitle">
            MICRO 24 changes fuel behaviour at the <span className="hl">droplet level</span> — optimising
            <span className="hl"> flash point</span>, <span className="hl">droplet size</span>, and
            <span className="hl"> combustion speed</span> for a cleaner, more complete burn.
          </p>
        </div>

        <div className="how-grid">
          {/* LEFT: WITHOUT */}
          <div className="how-card how-card-muted">
            <div className="how-card-header">
              <span className="how-chip how-chip-bad">Without MICRO 24</span>
              <h3>Conventional Fuel Behaviour</h3>
            </div>

            <ul className="how-bullets">
              <li>
                Large, uneven droplets → <span className="hl-soft">low surface area</span>
              </li>
              <li>
                Poor air mixing → <span className="hl-soft">limited oxygen contact</span>
              </li>
              <li>
                Heavy hydrocarbons → <span className="hl-soft">incomplete ignition</span>
              </li>
              <li>
                Slow combustion → <span className="hl-soft">unstable flame</span>
              </li>
            </ul>

            <div className="how-divider" />

            <div className="how-mini-title">Outcome</div>
            <ul className="how-bullets">
              <li>
                High soot / CO / unburnt hydrocarbons
              </li>
              <li>
                Sludge build-up in guns, nozzles & chambers
              </li>
              <li>
                Frequent cleaning and inconsistent performance
              </li>
            </ul>
          </div>

          {/* CENTER: RESULT (HERO) */}
          <div className="how-card how-card-result">
            <div className="how-card-header center">
              <span className="how-chip how-chip-good">Result</span>
              <h3>Maximum Energy. Minimal Residue.</h3>
            </div>

            <div className="how-result-grid">
              <div className="how-kpi">
                <div className="how-kpi-label">Combustion</div>
                <div className="how-kpi-value">More complete</div>
              </div>
              <div className="how-kpi">
                <div className="how-kpi-label">Residue</div>
                <div className="how-kpi-value">Negligible</div>
              </div>
              <div className="how-kpi">
                <div className="how-kpi-label">Exhaust</div>
                <div className="how-kpi-value">Cleaner</div>
              </div>
              <div className="how-kpi">
                <div className="how-kpi-label">Uptime</div>
                <div className="how-kpi-value">Higher</div>
              </div>
            </div>

            <div className="how-quote">
              Extracts <span className="hl">more usable energy per litre</span> while keeping burners,
              guns and chambers <span className="hl">cleaner for longer</span>.
            </div>
          </div>

          {/* RIGHT: WITH */}
          <div className="how-card how-card-highlight">
            <div className="how-card-header">
              <span className="how-chip how-chip-good">With MICRO 24</span>
              <h3>Micro-Optimised Fuel</h3>
            </div>

            <ul className="how-bullets">
              <li>
                Acts as a <span className="hl-soft">surfactant + combustion catalyst</span>
              </li>
              <li>
                Breaks surface tension → <span className="hl-soft">fine micro-droplets</span>
              </li>
              <li>
                Higher surface area → <span className="hl-soft">oxygen reaches every droplet</span>
              </li>
            </ul>

            <div className="how-divider" />

            <div className="how-mini-title">
              Micro-Explosive Combustion <span className="temp">300–305°C</span>
            </div>

            <ul className="how-bullets">
              <li>
                Long chains crack → <span className="hl-soft">shorter reactive molecules</span>
              </li>
              <li>
                Uniform oxidation → <span className="hl-soft">stable, efficient flame</span>
              </li>
              <li>
                Reduced ignition delay → <span className="hl-soft">faster, cleaner light-up</span>
              </li>
            </ul>
          </div>
        </div>
      </div>
    </section>
  );
};

export default HowItWorks;
